
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { usePolicyCreation } from './retention/usePolicyCreation';
import { useRetentionExecution } from './retention/useRetentionExecution';
import { usePolicyFetching } from './retention/usePolicyFetching';
import { usePolicyDeletion } from './retention/usePolicyDeletion';

export function useRetentionPolicies() {
  const { toast } = useToast();
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  
  // Use the smaller, more focused hooks
  const { 
    policies, 
    isLoading, 
    error, 
    refetch 
  } = usePolicyFetching();
  
  const { 
    createPolicyMutation,
    isSubmitting,
    onSubmitPolicy
  } = usePolicyCreation({ setIsAddDialogOpen });
  
  const {
    isProcessing,
    handleRunRetention
  } = useRetentionExecution();

  const {
    isDeleting,
    onDeletePolicy
  } = usePolicyDeletion();

  return {
    policies,
    isLoading,
    error,
    refetch,
    isAddDialogOpen,
    setIsAddDialogOpen,
    isProcessing,
    handleRunRetention,
    onSubmitPolicy,
    onDeletePolicy,
    isSubmitting,
    isDeleting
  };
}
